import { Select } from '@/components/atoms/form-select'

import { SIZE_OPTIONS } from './data-options'

interface RegulationListHeaderProps {
  setCategory?: (value: string) => void
  setSize?: (value: string) => void
  categoryList: string[]
}

export const RegulationListHeader = ({ setSize, setCategory, categoryList }: RegulationListHeaderProps) => {
  const REGULATION_OPTIONS = [
    { label: 'Semua Peraturan', value: 'Semua Peraturan' },
    ...categoryList.map((item: string) => ({
      label: item,
      value: item
    }))
  ]

  return (
    <header className="space-y-10">
      <div className="flex items-end justify-between gap-4 lg:items-center">
        <div className="flex flex-col gap-3 lg:items-center lg:flex-row">
          <span className="text-sm font-semibold lg:text-base">Kategori:</span>
          <Select
            name="category"
            variant="single"
            placeholder="Semua Peraturan"
            defaultValue="Semua Peraturan"
            option={REGULATION_OPTIONS}
            className="w-auto"
            onValueChange={setCategory}
          />
        </div>
        <div className="flex items-center gap-3">
          <span className="text-sm font-medium text-gray-600 lg:text-base">Tampil</span>
          <Select
            name="size"
            variant="single"
            placeholder="Size"
            defaultValue="5"
            option={SIZE_OPTIONS}
            className="w-auto"
            align="end"
            onValueChange={setSize}
          />
        </div>
      </div>
      <h2 className="text-xl font-bold">Semua Peraturan</h2>
    </header>
  )
}
